import React, { useState } from 'react';
import { TextField, Button, Grid, Paper, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const Form = ({formData, fetchData,handleClose,handleFetchSuccess,handleFetchFailure}) => {
  const navigate = useNavigate();

    // console.log(formData)
  const [data, setData] = useState({
    name: formData.name,
    id:formData._id
  });
  const [editMode, setEditMode] = useState(false);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {

    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${data.id}`, {
        method: 'PUT', // or 'POST' if applicable
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      if (!response.ok) {
        handleFetchFailure();
     
        throw new Error('Network response was not ok');
      }
      // console.log('Form data submitted successfully');
      setEditMode(false);
        fetchData();
        handleFetchSuccess();
     
        handleClose();
    } catch (error) {
      handleFetchFailure();
      console.error('Error submitting form data:', error);
   
      handleClose();
    }
  };


  
  const handleDelete = async (id) => {

    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    const confirmed = window.confirm('Are you sure you want to delete this product?');

  if (!confirmed) {
    return; // If user cancels, do not proceed with deletion
  }
    try {
      // Make a DELETE request to your API endpoint
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${data.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          // Add any other headers as needed, such as authorization headers
        },
        body: JSON.stringify(data),
      });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
  
      if (!response.ok) {
        handleFetchFailure();
     
        handleClose();
        throw new Error('Failed to delete item');
      }
  
      // If the deletion was successful, update the state to remove the deleted item
      setData(prevState => {
        const { [id]: deletedItem, ...rest } = prevState;
        return rest;
      });
  
      // Optionally, show a success message or perform other actions
      // console.log('Item deleted successfully');
      fetchData();
      handleFetchSuccess();
   
      handleClose();
    } 
    
    catch (error) {
      handleFetchFailure();
   
      handleClose();
      console.error('Error deleting item:', error.message);
      // Handle error scenarios, such as showing an error message to the user
    }
  };
  

  return (
    <Grid container justifyContent="center" className=''>
      <Grid item>
        <Paper elevation={0} style={{ padding: '5px', maxHeight: '70vh', overflowY: 'auto' }} >
          {editMode ? (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                margin="normal"
                label="Campaign Name"
                id="name"
                name="name"
                value={data.name}
                onChange={handleChange}
                required
              />
              <div>
              <Button variant="contained" type="submit"
              sx={{borderRadius:'20px',backgroundColor: 'var(--color-button)', '&:hover': {
                backgroundColor: 'var(--color-button-hover)', 
            },}}>
                Submit
              </Button>
             
              </div>
            </form>
          ) : (
            <div>
              <TextField
                fullWidth
                margin="normal"
                label="Campaign Name"
                value={data.name}
                InputProps={{ readOnly: true }}
              />
            
              <div className='flex justify-between'>
              <Button variant="contained"  sx={{borderRadius:'20px',backgroundColor: 'var(--color-button)', '&:hover': {
                backgroundColor: 'var(--color-button-hover)', 
                },}} onClick={handleEdit}>
                Edit
              </Button>
              <Button variant="contained"  sx={{borderRadius:'20px',backgroundColor: 'var(--color-button)', '&:hover': {
                backgroundColor: 'var(--color-button-hover)', 
                },}} onClick={handleDelete}>
                Delete
              </Button>
              </div>
            </div>
          )}
        </Paper>
      </Grid>
    </Grid>
    
  );
};

export default Form;
